/* tslint:disable */
/* eslint-disable */
/**
 * Mild Blue s.r.o. - Online Connect
 * Application allowing people to ask for admition in IKEM.
 *
 * The version of the OpenAPI document: development
 * Contact: support@mild.blue
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EnumsDtoOut } from '../model';
// @ts-ignore
import { OkResponse } from '../model';
// @ts-ignore
import { PublicAccessInfoDto } from '../model';
// @ts-ignore
import { ServiceHealth } from '../model';
// @ts-ignore
import { ServiceVersion } from '../model';
/**
 * ServiceApi - axios parameter creator
 * @export
 */
export const ServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Responds OK if the user is authenticated. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCookieGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cookie`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication sessionAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes all auth cookies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCookieLogoutPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cookie/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns enums that the application uses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnumsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/enums`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Always responds with HTTP status 200 if the application is up and running.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatusGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns description of the service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatusHealthGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/status/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns version of the application.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVersionGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceApi - functional programming interface
 * @export
 */
export const ServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Responds OK if the user is authenticated. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCookieGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicAccessInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCookieGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes all auth cookies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCookieLogoutPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCookieLogoutPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns enums that the application uses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnumsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumsDtoOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnumsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Always responds with HTTP status 200 if the application is up and running.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStatusGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStatusGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns description of the service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStatusHealthGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceHealth>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStatusHealthGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns version of the application.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVersionGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVersionGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ServiceApi - factory interface
 * @export
 */
export const ServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Responds OK if the user is authenticated. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCookieGet(options?: any): AxiosPromise<PublicAccessInfoDto> {
            return localVarFp.apiCookieGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes all auth cookies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCookieLogoutPost(options?: any): AxiosPromise<OkResponse> {
            return localVarFp.apiCookieLogoutPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns enums that the application uses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnumsGet(options?: any): AxiosPromise<EnumsDtoOut> {
            return localVarFp.apiEnumsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Always responds with HTTP status 200 if the application is up and running.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatusGet(options?: any): AxiosPromise<OkResponse> {
            return localVarFp.apiStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns description of the service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatusHealthGet(options?: any): AxiosPromise<ServiceHealth> {
            return localVarFp.apiStatusHealthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns version of the application.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVersionGet(options?: any): AxiosPromise<ServiceVersion> {
            return localVarFp.apiVersionGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceApi - object-oriented interface
 * @export
 * @class ServiceApi
 * @extends {BaseAPI}
 */
export class ServiceApi extends BaseAPI {
    /**
     * 
     * @summary Responds OK if the user is authenticated. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public apiCookieGet(options?: any) {
        return ServiceApiFp(this.configuration).apiCookieGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes all auth cookies.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public apiCookieLogoutPost(options?: any) {
        return ServiceApiFp(this.configuration).apiCookieLogoutPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns enums that the application uses.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public apiEnumsGet(options?: any) {
        return ServiceApiFp(this.configuration).apiEnumsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Always responds with HTTP status 200 if the application is up and running.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public apiStatusGet(options?: any) {
        return ServiceApiFp(this.configuration).apiStatusGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns description of the service health.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public apiStatusHealthGet(options?: any) {
        return ServiceApiFp(this.configuration).apiStatusHealthGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns version of the application.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public apiVersionGet(options?: any) {
        return ServiceApiFp(this.configuration).apiVersionGet(options).then((request) => request(this.axios, this.basePath));
    }
}
